import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd054e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-card" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 已完成")
const _hoisted_3 = { style: {"color":"#3f7cff","font-size":"14px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("次/最低巡检")
const _hoisted_5 = { style: {"color":"#d69340","font-size":"14px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("次 ")
const _hoisted_7 = { class: "right-card" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshing2,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refreshing2) = $event)),
      onRefresh: _ctx.onRefresh2
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.loading2,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading2) = $event)),
          finished: _ctx.finished2,
          "finished-text": "没有更多了",
          "loading-text": "正在加载,请稍后..",
          onLoad: _ctx.onLoad2
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (li, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card",
                key: index
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", null, _toDisplayString(li.name), 1),
                  _createElementVNode("div", null, [
                    _hoisted_2,
                    _createElementVNode("span", _hoisted_3, _toDisplayString(li.countFinish == null ? 0 : li.countFinish), 1),
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, _toDisplayString(li.everydayTimes), 1),
                    _hoisted_6
                  ]),
                  _createElementVNode("div", null, [
                    (li.countFinish == null)
                      ? (_openBlock(), _createBlock(_component_van_progress, {
                          key: 0,
                          "stroke-width": "8",
                          percentage: 0,
                          style: {"display":"inline-block","width":"100%"},
                          "pivot-text": ""
                        }))
                      : (_openBlock(), _createBlock(_component_van_progress, {
                          key: 1,
                          "stroke-width": "8",
                          percentage: _ctx.getPercent2(li.countFinish, li.everydayTimes),
                          style: {"display":"inline-block","width":"100%"},
                          "pivot-text": ""
                        }, null, 8, ["percentage"]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.startInspect(li))
                    }, "开始巡检", 8, _hoisted_8)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}